<template>
  <div v-loading="loading">
    <p class="font-16 blue mb10">服务评分：</p>
    <el-rate :value="mark" show-score text-color="#ff9900" disabled></el-rate>

    <p class="mt20 font-16 blue mb10">我的评分：</p>
    <el-rate v-model="myMark" show-score text-color="#ff9900"></el-rate>

    <p class="tx-c mt20">
      <el-button type="primary" size="mini" @click="submitScore">提交评分</el-button>
    </p>
  </div>
</template>

<script>
export default {
  name: "MarkCard",
  components: {},
  props: [],
  data() {
    return {
      loading: false,

      mark: 0,
      myMark: 0,

      serveId: this.$route.params.serveId,
      processInstId: "",
      serverName: ""
    };
  },
  computed: {},
  created() {
    this.fetchScore();
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchScore() {
      this.loading = true;
      this.$http
        .get("/serveCenter/getScore", {
          params: {
            serveId: this.serveId
          }
        })
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.mark = data.resData.avgScore;
            this.myMark = data.resData.scoreDuration;
            this.serverName = data.resData.serverName;
            this.processInstId = data.resData.processInstId;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitScore() {
      this.loading = true;
      this.$http
        .post(
          "/serveCenter/addOrUpdateScore",
          JSON.stringify({
            serveId: this.serveId,
            scoreDuration: this.myMark,
            processInstId: this.processInstId,
            serverName: this.serverName
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          }
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.$message.success(data.resMsg);
            this.$nextTick(() => {
              this.fetchScore();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
